import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ListView from '../Common/ListView.react';
import ListItem from './EmailTemplateListItem';
import CancelIcon from 'material-ui/svg-icons/navigation/cancel';

import EmailTemplateActions from '../../actions/EmailTemplateActionCreator';
import EmailTemplateStore from '../../stores/EmailTemplateStore';

import buildContextMenu from '../Common/BuildContextMenu';

class EmailTemplatesList extends Component {

    constructor (props) {
        super(props);
        this.state = {
            emailTemplates: [],
            count: 0,
            page: 0,
            limit: 50,
            actions: [],
            sortCriteria: null,
            sortMapCriteria: null
        };
        this.onChange = this.onChange.bind(this);
        this.sort = this.sort.bind(this);
    }

    componentDidMount() {
        this.listener = EmailTemplateStore.addListener(this.onChange);
        EmailTemplateActions.getAll({limit: this.state.limit});
        this.setState({actions: buildContextMenu(this.getActions(), this.context.auth)});
    }

    componentWillUnmount() {
        this.listener.remove();
    }

    getActions() {
        return [
            {
                link: '/logout',
                icon: <CancelIcon />,
                label: 'Sign out',
            },
        ];
    }

    render() {

        return (
            <ListView
                title="Email templates"
                sortOptions={this.props.sortOptions}
                sortAction={this.sort}
                actions={this.state.actions}
                items={this.state.emailTemplates}
                itemDecorator={ListItem}
                newEntityUrl={this.context.auth.isAdmin() ? '/dashboard/email/template/new' : ''}
            />
        )
    }

    onChange() {
        const emailTemplates = EmailTemplateStore.getAll({limit: this.state.limit});
        if (!!emailTemplates) {
            if (emailTemplates.length <= 1 || !this.state.sortCriteria || !this.state.sortMapCriteria) {
                this.setState({emailTemplates});
            } else {
                const mapped = emailTemplates.map(this.state.sortMapCriteria);
                mapped.sort(this.state.sortCriteria);
                const sortedTemplates = mapped.map((el) => emailTemplates[el.index]);
                this.setState({emailTemplates: sortedTemplates});
            }
        }
    }

    sort(options) {
        let sortCriteria, sortMapCriteria;
        switch (options.sort) {
            case 'name':
                sortCriteria = (a, b) => a.value.localeCompare(b.value);
                sortMapCriteria = (el, i) => ({index: i, value: el.name});
                break;
            case 'dateUpdated':
                sortCriteria = (a, b) => (b.value - a.value);
                sortMapCriteria = (el, i) => ({index: i, value: Date.parse(el.dateUpdated)});
                break;
            default:
                sortCriteria = (a, b) => (a.value - b.value);
                sortMapCriteria = (el, i) => ({index: i, value: el[this.state.sort]});
        }
        this.setState({sort: options.sort, sortCriteria, sortMapCriteria});
        EmailTemplateActions.getAll({sort: options.sort});
    }
}

EmailTemplatesList.contextTypes = {
    auth: PropTypes.object.isRequired
};

EmailTemplatesList.defaultProps = {
    sortOptions: [
        {label: 'Name', value: 'name'},
        {label: 'Last updated', value: 'dateUpdated'},
    ]
};

export default EmailTemplatesList;
